import { useCallback, useEffect, useState } from "react"
import Cropper from "react-easy-crop"

const getCroppedImg = async (imageSrc, crop) => {
  return new Promise(async (resolve, reject) => {
    if (!imageSrc || !crop?.width || !crop?.height) {
      return
    }

    // this is used to prevent the native element request because they suffer from CORS due to missing ORIGIN header
    const response = await fetch(imageSrc, {
      method: "GET",
      mode: "cors",
      cache: "no-store",
    })

    const blob = await response.blob()
    const imageUrl = URL.createObjectURL(blob)
    const img = new Image()
    img.src = imageUrl
    img.crossOrigin = "anonymous"

    img.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = crop.width
      canvas.height = crop.height

      const ctx = canvas.getContext("2d")
      ctx.drawImage(img, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height)

      const base64 = canvas.toDataURL("image/jpeg")
      resolve(base64)
    }

    img.onerror = err => reject(err)
  })
}

const CustomCropper = ({ image, crop, zoom, aspectRatio, onCropChange, onZoomChange, onCropComplete, ...rest }) => {
  let onCropCompleteIntercept = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      let getCroppedImageBase64 = await getCroppedImg(image, croppedAreaPixels)
      onCropComplete(croppedArea, croppedAreaPixels, getCroppedImageBase64)
    },
    [image, onCropComplete]
  )

  return (
    <Cropper
      image={image}
      crop={crop}
      zoom={zoom}
      aspect={aspectRatio}
      onCropChange={onCropChange}
      onCropComplete={onCropCompleteIntercept}
      onZoomChange={onZoomChange}
      objectFit="vertical-cover"
      style={{
        mediaStyle: { filter: "brightness(0.7)" },
        cropAreaStyle: { border: "2px solid white" },
      }}
      zoomWithScroll
      {...rest}
    />
  )
}

export default CustomCropper
